import { render, staticRenderFns } from "./COMScreen4.vue?vue&type=template&id=780d4e1d"
import script from "./COMScreen4.vue?vue&type=script&lang=js"
export * from "./COMScreen4.vue?vue&type=script&lang=js"
import style0 from "./COMScreen4.vue?vue&type=style&index=0&id=780d4e1d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports